import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from 'src/hooks';
import { getSelectedSiteDataSelector } from 'src/redesign/features/SelectedSite/store/selectors';

export const TicketPacksBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const history = useHistory();
  const site = useAppSelector(getSelectedSiteDataSelector);

  useEffect(() => {
    // Check if banner was dismissed
    const dismissed = localStorage.getItem('ticketPacksBannerDismissed');
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('ticketPacksBannerDismissed', 'true');
  };

  const handleClick = () => {
    if (site?.id) {
      history.push(`/events/billing?view=packs`);
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: 'var(--brand-background-color)',
        color: 'white',
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        cursor: 'pointer',
      }}
      onClick={handleClick}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          maxWidth: '1200px',
          width: '100%',
          paddingRight: '40px',
        }}
      >
        <span
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            padding: '4px 12px',
            borderRadius: '4px',
            fontWeight: '600',
            fontSize: '14px',
            whiteSpace: 'nowrap',
          }}
        >
          NEW
        </span>
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            flexWrap: 'wrap',
          }}
        >
          <span style={{ fontWeight: '600', fontSize: '15px', whiteSpace: 'nowrap' }}>
            Ticket Packs
          </span>
          <span
            style={{
              fontSize: '14px',
              opacity: 0.95,
              lineHeight: '1.4',
            }}
          >
            Selling a one-off event or seasonal launch? Buy tickets upfront - no subscriptions, no
            per-ticket fees.
          </span>
        </div>
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          handleDismiss();
        }}
        style={{
          position: 'absolute',
          right: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'transparent',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          padding: '4px 8px',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: 0.8,
          transition: 'opacity 0.2s',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.8')}
        aria-label="Dismiss banner"
      >
        <i className="pi pi-times" style={{ fontSize: '16px' }} />
      </button>
    </div>
  );
};
